module.exports = __webpack_public_path__ + "static/media/doodles.86377fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/AUTH_PAGE/images/textures/doodles.png
// module id = 291
// module chunks = 0